import React from 'react';
import { trackEvent } from '../utils/analytics';
import './HeroPoster.css';

// Swap the poster by replacing the file in frontend/public and, if the new art
// has a different shape, updating width/height below (they reserve the space
// before the image loads, so the page doesn't jump). Add a `mobile` entry with
// the same shape to serve separate phone art.
export const HERO_POSTER = {
  desktop: { src: '/hero-poster.webp', width: 2000, height: 667 },
  mobile: null,
  alt: 'Buy new taxis at the best price — get the best price from BuySellTaxi on WhatsApp',
  href: `https://wa.me/919560759834?text=${encodeURIComponent('Hi, I saw your poster on BuySellTaxi.com. Please share the best price for a new taxi.')}`,
};

const HeroPoster = () => {
  const { desktop, mobile, alt, href } = HERO_POSTER;
  const phone = mobile || desktop;
  return (
    <a
      href={href}
      onClick={() => trackEvent('whatsapp_enquiry_click', { placement: 'hero_poster' })}
      target="_blank"
      rel="noopener noreferrer"
      className="hero-poster"
      data-testid="hero-poster"
      style={{
        '--poster-ratio-desktop': `${desktop.width} / ${desktop.height}`,
        '--poster-ratio-mobile': `${phone.width} / ${phone.height}`,
      }}
    >
      <picture>
        {mobile && (
          <source media="(max-width: 640px)" srcSet={mobile.src} width={mobile.width} height={mobile.height} />
        )}
        <img
          src={desktop.src}
          width={desktop.width}
          height={desktop.height}
          alt={alt}
          fetchpriority="high"
          decoding="async"
        />
      </picture>
    </a>
  );
};

export default HeroPoster;
